import { useRoutes } from 'react-router-dom';
import AppLayout from '@/components/Layout/AppLayout';
import { amlRoutes } from '@/routes/AmlRoutes';
import { connectraRoutes } from '@/routes/ConnectraRoutes';
import { generalRoutes } from '@/routes/GeneralRoutes';
import { gmcRoutes } from '@/routes/GmcRoutes';
import { usersRoutes } from '@/routes/UsersRoutes';
import ErrorHandler from '@/utils/ErrorHandler';

export function AppRoutes() {
	const element = useRoutes([
		{
			element: <AppLayout />,
			children: [
				...generalRoutes,
				...amlRoutes,
				...connectraRoutes,
				...usersRoutes,
				...gmcRoutes,
			],
		},
	]);

	return <ErrorHandler componentName="AppRoutes">{element}</ErrorHandler>;
}
